import React from "react";
import { Card, CardActionArea, CardContent } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";
import CommonContainer from "./common/CommonContainer";
import { useDispatch, useSelector } from "react-redux";
import { userAccount } from "../../store/auth/selector";
import { RootState } from "../../store/config/types";
import probes from "../../assets/probe-tubes.png";
import search from "../../assets/search-pizza.png";
import meal from "../../assets/step4.png";
import MultiStepForm from "./common/MultiStepForm";
import UserProfile, { UserProfileData } from "./UserProfile";
import CollapsibleSection from "./common/CollapsibleSection";

function Landing({ history }: RouteComponentProps) {
  const dispatch = useDispatch();
  const actualUser = useSelector((state: RootState) => userAccount(state));

  // Formar una clave dinámica usando el email del usuario logueado
  const profileKey = "userProfileData_" + actualUser.email;

  const storedUserData = localStorage.getItem(profileKey);
  let userProfileData: UserProfileData;
  if (storedUserData) {
    userProfileData = JSON.parse(storedUserData);
  } else {
    userProfileData = {
      ...actualUser.profile,
      email: actualUser.email,
      firstTimeDashboard: true, // Si no hay datos, se asume que es la primera vez
      imc: 0,
      recommendedCaloriesPerDay: 0,
      recommendedDailyWater: 0,
      recommendedDailyProteins: 0,
      recommendedDailyCarbos: 0,
      recommendedDailyFats: 0,
    };
  }

  // Si firstTimeDashboard es false, se considera que el formulario ya fue completado.
  const formCompleted = userProfileData.firstTimeDashboard === false;

  return (
    <CommonContainer>
      {!formCompleted ? (
        <CollapsibleSection title="Completar formulario" defaultExpanded={false} titleColor="red">
          <MultiStepForm history={history} profileKey={profileKey} />
        </CollapsibleSection>
      ) : (
        <CollapsibleSection title="Mi perfil" defaultExpanded={true} titleColor="black">
          <UserProfile user={userProfileData} />
        </CollapsibleSection>
      )}
      <div className="landing-container" style={{ minHeight: "300px", justifyContent: "space-around" }}>
      {/* <div className="landing-container"> */}
        <MenuCard
          icon={probes}
          title="Resultados"
          onClick={() => history.push("/results")}
          description="Conocé la forma en que tu cuerpo asimila los distintos nutrientes."
        />
        <MenuCard
          icon={search}
          title="Recomendaciones"
          onClick={() => history.push("/foods")}
          description="Descubrí sobre una lista de casi 300 alimentos cuales debes preferir, moderar y evitar su consumo."
        />
        <MenuCard
          icon={meal}
          title="Platos semanales"
          onClick={() => history.push("/platos-semanales")}
          description="Contratá platos ricos, saludables y personalizados semanalmente directo a tu puerta."
        />
      </div>
    </CommonContainer>
  );
}

function MenuCard({
  icon,
  title,
  description,
  onClick,
}: {
  icon: string;
  title: string;
  description: string;
  onClick: () => void;
}) {
  return (
    <Card className="card" elevation={3}>
      <CardActionArea onClick={onClick}>
        <CardContent className="card-content">
          <div className="img-container">
            <img src={icon} alt="" />
          </div>
          <div className="text">
            <h3 className="title">{title}</h3>
            <p>{description}</p>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default withRouter(Landing);

/* <MenuCard
          icon={agenda}
          title="Agenda"
          onClick={() => history.push("/agenda")}
          description="Agendá consultas con nutricionistas especialistas en interpretar los resultados nutrigenéticos."
        /> */